import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { HistoricoInventariosApi } from "../api/HistoricoInventariosApi";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { FiltrosHistorico } from "./FiltrosHistorico";
import { HistoricoTable } from "./HistoricoTable";
import { useDebounce } from "../../../../../Utils/Hooks/useDebounce";
import { dateToDayStart, getErrorFromResponse } from "../../../../../../../utility/utils";
import { FormInventario } from "./FormInventario";
import { DecisionSwal } from "../../../../../Utils/Utils/DecisionSwal";

import Swal from "sweetalert2";
const alerta = require("assets/img/icons/alerta_roja.png");

export const Historico = ({
    storageKey,
    navigateToCreacion,
    navigateToInventarioInicial,
    nombreAcopio,
}) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const searchDefault = filtros.search || "";
    const fechaInicialDefault = filtros.fecha_inicial
        ? moment(filtros.fecha_inicial)
        : null;

    const fechaFinalDefault = filtros.fecha_final
        ? moment(filtros.fecha_final)
        : null;

    const { control, watch } = useForm({
        defaultValues: {
            search: searchDefault,
            fecha_inicial: fechaInicialDefault,
            fecha_final: fechaFinalDefault,
        },
    });

    const [inventarios, setInventarios] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);
    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const {
        getHistoricosInventario,
        getFechaUltimoInventario,
        deleteHistoricoInventario,
        reabrirHistoricoInventario,
        cargando,
    } = HistoricoInventariosApi();

    const GetHistoricosInventario = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayStart(fecha_final);
            }

            const response = await getHistoricosInventario(params);
            setInventarios(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener historicos de inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setInventarios([]);
            setCantidadResultados(0);
        }
    };

    const EliminarHistoricoInventario = async (id) => {
        try {
            await deleteHistoricoInventario(id);
            NotificationManager.success(
                "Historico de inventario eliminado correctamente",
                "Éxito",
                3000,
            );
            GetHistoricosInventario();
            ObtenerFechaUltimoInventario();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar historico de inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const MostrarMensajeEliminacionInventario = (id) => {
        const mensaje =
            "¿Está seguro de eliminar este inventario? También se eliminarán la gestión de sus almacenes y sus solicitudes de análisis de DRC.";

        DecisionSwal(mensaje, "Sí", "No", () =>
            EliminarHistoricoInventario(id),
        );
    };

    const ReabrirHistoricoInventario = async (id) => {
        try {
            await reabrirHistoricoInventario(id);
            NotificationManager.success(
                "Inventario reabierto correctamente",
                "Éxito",
                3000,
            );
            GetHistoricosInventario();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al reabrir el inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const MostrarMensajeReaperturaInventario = (id) => {
        const mensaje =
            "¿Está seguro de reabrir este inventario? Sus almacenes podrán gestionarse nuevamente y sus cifras se recalcularán al cerrarlo.";

        DecisionSwal(mensaje, "Sí", "No", () =>
            ReabrirHistoricoInventario(id),
        );
    };

    useEffect(() => {
        GetHistoricosInventario();
    }, [paginaSeleccionada, debouncedSearch, fecha_inicial, fecha_final]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                search: debouncedSearch,
                fecha_inicial,
                fecha_final,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [debouncedSearch, fecha_inicial, fecha_final, paginaSeleccionada]);

    const [modalIngresosAbierto, setModalIngresosAbierto] = useState(false);

    const MostrarAlertaInvInicial = () => {
        const SwalMod = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-dark mr-5",
                content: "d-flex justify-content-center mb-4",
                title: "verde-primario",
                image: "blink-danger",
            },
            buttonsStyling: false,
            focusConfirm: false,
            focusCancel: false,
        });
        SwalMod.fire({
            title: "¡ADVERTENCIA!",
            text: "No se ha configurado el inventario inicial ¿Desea configurarlo ahora?",
            imageUrl: alerta,
            imageAlt: "Alerta",
            showCancelButton: true,
            confirmButtonText: "SI",
            cancelButtonText: "NO",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                navigateToInventarioInicial();
            }
        });
    };

    const [fechaInicial, setFechaInicial] = useState(null);

    const ObtenerFechaUltimoInventario = async () => {
        try {
            const response = await getFechaUltimoInventario();
            if (response && response.fecha) {
                setFechaInicial(moment(response.fecha));
            } else {
                setFechaInicial(null);
            }
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener fecha del último inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        ObtenerFechaUltimoInventario();
    }, []);

    const handleNuevoInventarioClick = () => {
        // buscar si hay un inventario abierto (estado === ABIERTO)
        const inventarioAbierto = inventarios.find(
            (inv) => inv.estado === "ABIERTO",
        );

        if (inventarioAbierto) {
            Swal.fire({
                title: "¡ADVERTENCIA!",
                text: "Ya existe un inventario abierto. Cierre el inventario abierto antes de crear uno nuevo.",
                imageUrl: alerta,
                imageAlt: "Alerta",
                confirmButtonText: "OK",
                customClass: {
                    confirmButton: "btn btn-primary",
                    content: "d-flex justify-content-center mb-4",
                    title: "verde-primario",
                    image: "blink-danger",
                },
                buttonsStyling: false,
            });
            return;
        }

        if (fechaInicial) {
            setModalIngresosAbierto(true);
        } else {
            MostrarAlertaInvInicial();
        }
    };

    return (
        <div className="historico-inventarios__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div
                        className="d-flex justify-content-end "
                        style={{ gap: "5px" }}
                    >
                        <label>Acopio:</label>
                        <span>{nombreAcopio}</span>
                    </div>

                    <div className="historico-inventarios__table-header">
                        <FiltrosHistorico
                            control={control}
                            onRefresh={() => {
                                GetHistoricosInventario();
                                ObtenerFechaUltimoInventario();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"ID Inventario"}
                        />
                        <button
                            className="btn btn-primary"
                            onClick={handleNuevoInventarioClick}
                        >
                            Crear nuevo inventario
                        </button>
                    </div>

                    <HistoricoTable
                        inventarios={inventarios}
                        EliminarHistoricoInventario={
                            MostrarMensajeEliminacionInventario
                        }
                        ReabrirHistoricoInventario={
                            MostrarMensajeReaperturaInventario
                        }
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
            <FormInventario
                opened={modalIngresosAbierto}
                onClose={() => setModalIngresosAbierto(false)}
                navigateToCreacion={navigateToCreacion}
                fechaInicial={fechaInicial}
            />
        </div>
    );
};
